import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Typography,
  Link,
  Alert,
  IconButton,
  Menu,
  FormControlLabel,
  Checkbox,
  Icon,
  Avatar,
  Dialog,
  TextField,
  FormControl,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { filter, sumBy } from 'lodash';

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Popover from '@mui/material/Popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AlertDialog from "../../../components/AlertDialog";
import SimpleDialog from "../../../components/SimpleDialog";
import ConfirmDialog from "../../../components/ConfirmDialog";
import WarningDialog from "../../../components/WarningConfirm";
import ConfirmAdjustGoal from "../../../views/app/kpi/ConfirmAdjustGoal";


import { ReactComponent as PlusIcon } from "../../../icons/plus.svg";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
// import Request from "../../components/home/Request";
// import { getMyRequestSuccess } from "../../actions";
import { useSelector, useDispatch } from "react-redux";
import { getGoalList, deleteMyGoal, postSubmitApproval, getMyGoalDetail, putUpdateProgress, getMyGoalProgress, putDeleteMyGoal, getGoalCycle } from "../../../actions/mygoal";
import { postWorkflowSubmit } from "../../../actions/inboxKpi";

import { Link as RouterLink, useNavigate, useParams, useLocation } from 'react-router-dom'
import React, { useEffect } from "react";
import fileBrowser from "../../../icons/file-browser.svg";
import { styled } from "@mui/material/styles";
import cssVariables from "../../../theme/cssVariables";
import MessageDialog from "../../../components/inbox/MessageDialog";
// import ExportIcon from "../../../icons/export.svg";
// import SeeChartIcon from "../../../icons/see-chart.svg";
import { ReactComponent as ExportIcon } from "../../../icons/export.svg";
import { ReactComponent as SeeChartIcon } from "../../../icons/see-chart.svg";
import { ReactComponent as GoalWeightIcon } from "../../../icons/goal-weight.svg";
import { ReactComponent as StatusGraphIcon } from "../../../icons/status-graph.svg";
import { ReactComponent as FilterIcon } from "../../../icons/filter.svg";
import { ReactComponent as LinkIcon } from "../../../icons/link.svg";
import ArrowRight from "../../../icons/arrow-circle-right.svg";
import ArrowBottom from "../../../icons/arrow-circle-bottom.svg";
import { ReactComponent as TooltipIcon } from "../../../assets/images/tooltip.svg";
import { ReactComponent as SubmitButton } from "../../../icons/submit-button.svg";
import { ReactComponent as Profile } from "../../../icons/profile.svg";
import { ReactComponent as EyeIcon } from "../../../icons/eye.svg";
import { ReactComponent as EditIcon } from "../../../icons/edit.svg";
import { ReactComponent as CancelDelete } from "../../../icons/cancel-delete.svg";
import { ReactComponent as DeleteIcon } from "../../../icons/delete.svg";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import * as Util from "../../../services/global.service";
import Chart from 'react-apexcharts'
import dayjs from 'dayjs'

import ClearIcon from "@mui/icons-material/Clear";

const MyGoal = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  let { serial } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();

  // Variable Start
  const [workloadFormSelect, setWorkloadForm] = React.useState([]);
  const [workloadFormSelectValue, setWorkloadFormValue] = React.useState("");
  const handleChangeWorkloadForm = (event) => {
    setWorkloadFormValue(event.target.value);
    loadDataGoal(event.target.value)
  };
  const [selectedWorkloadType, setWorkloadTypeSelected] = React.useState("all");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const openOption = Boolean(anchorEl);
  const options = [
    t('mygoal.label.viewDetail'),
    t('mygoal.label.edit'),
    t('mygoal.label.delete'),
  ];
  const [showSummary, setShowSummary] = React.useState(0);
  const [alertSummary, showAlertSummary] = React.useState(false);
  const [goalProcess, setGoalProcess] = React.useState({
    date: null,
    Graph: {
      data: {
        value: [],
      }
    },
    more_data: [],
    total_goal: 0,
  })
  const [isApproveDialogOpen, openApproveDialog] = React.useState(false);
  const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
  const [isSuccessCancelDeleteDialogOpen, openSuccessCancelDeleteDialog] = React.useState(false);
  const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
  const [isCancelDeleteDialogOpen, openCancelDeleteDialog] = React.useState(false);
  const [isSuccessApprovalOpen, openSuccessApprovalOpen] = React.useState(false);
  const [fullVersion, setFullVersion] = React.useState(true);
  const [goalProgressOption, setGoalProgressOption] = React.useState([]);
  const [conditionBackup, setConditionBackup] = React.useState(true);
  const [openAdjust, setOpenAdjust] = React.useState(false);


  const [weightObject, setWeightObject] = React.useState({
    chart: {
      type: 'bar',
      stacked: true,
      stackType: "100%",
      toolbar: {
        show: false
      },
      offsetX: 0,
      offsetY: 15,
    },
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: -20,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "80%"
      },
    },
    dataLabels: {
      enabled: false
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.9,
        }
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff']
    },
    xaxis: {
      categories: ['Category Ratio'],
      labels: {
        show: false
      },
      axisTicks: {
        show: false
      },
      axisBorder: {
        show: false
      },
    },
    yaxis: {
      show: false,
    },
    tooltip: {
      enabled: true,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      style: {
        fontSize: '16px',
        fontFamily: "Kanit",
        fontWeight: 300,
      },
      x: {
        show: false,
      },
      y: {
        title: {
          formatter: (seriesName) => seriesName.length > 40 ? seriesName.substr(0, 40) + '...' : seriesName + ":",
        },
        style: {
          fontSize: '16px',
          fontFamily: "Kanit",
          fontWeight: 300,
        },
        formatter: function (val) {
          return val + '%';
        },
      },
      marker: {
        show: true,
      },
      items: {
        display: "flex",
      },
    },
    fill: {
      opacity: 1
    },
    legend: {
      show: false,
      position: 'bottom',
      horizontalAlign: 'left',
      offsetX: 10,
      formatter: function (val, opts) {
        return val;
      }
    },
  })
  const [emptyObject, setEmptyObject] = React.useState({
    chart: {
      offsetX: 30
    },
    dataLabels: {
      enabled: false
    },
    legend: {
      show: false
    },
    colors: ['#F5F5F5'],
    tooltip: {
      enabled: false,
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        }
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
            },
            value: {
              show: true,
              fontSize: '14px',
              fontFamily: "Kanit",
              fontWeight: 300,
              color: '#A3A3A3',
            },
            total: {
              show: true,
              showAlways: true,
              label: '0%',
              fontSize: '30px',
              fontFamily: 'Kanit',
              fontWeight: 600,
              color: '#5DA196',
              formatter: function (w) {
                return t('mygoal.label.complete')
              }
            },
            style: {
              fontFamily: 'Kanit',
            }
          }
        }
      }
    }
  })
  const [emptySeries, setEmptySeries] = React.useState([1])
  const [isAlertDialogOpen, openAlertDialogOpen] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [color, setColor] = React.useState("");
  const [colorHover, setColorHover] = React.useState("");
  const [size, setSize] = React.useState("");
  const [typeAlertDialog, setTypeAlertDialog] = React.useState("");
  const [errorText, seterrorText] = React.useState("");
  const [approveSummary, setApproveSummary] = React.useState(true);
  const open = Boolean(anchorEl2);
  const id = open ? 'simple-popover' : undefined;
  const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
  const [valueTab, setValueTab] = React.useState("all");
  const [evaluatorSerial, setEvaluatorSerial] = React.useState(null);
  const [deleteSerial, setDeleteSerial] = React.useState(null);
  const [isOwner, setIsOwner] = React.useState(false);
  const [isCreatable, setIsCreatable] = React.useState(false);
  const [proxyBy, setProxyBy] = React.useState(null);
  const [submittedBy, setSubmittedBy] = React.useState(null)
  const [allowAdjust, setAllowAdjust] = React.useState(false);
  const [currentRemark, setCurrentRemark] = React.useState(null);

  const [chartObject, setChartObject] = React.useState({
    chart: {
      offsetX: 30
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              offsetY: 25,
              formatter: () => t('mygoal.label.complete')
            },
            value: {
              show: true,
              fontSize: '30px',
              fontFamily: "Kanit",
              fontWeight: 600,
              color: undefined,
              offsetY: -15,
              color: '#5DA196',
              formatter: function (val) {
                return val
              }
            },
            total: {
              show: true,
              showAlways: true,
              fontSize: '14px',
              fontFamily: "Kanit",
              fontWeight: 300,
              color: '#A3A3A3',
              background: "#fff",
            }
          }
        }
      }
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.9,
        }
      },
    },
    stroke: {
      width: 0,
      colors: ["#fff"],
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      enabledOnSeries: undefined,
      shared: true,
      followCursor: false,
      intersect: false,
      inverseOrder: false,
      custom: undefined,
      fillSeriesColor: false,
      theme: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      style: {
        fontSize: '16px',
        fontFamily: "Kanit",
        fontWeight: 300,
      },
      x: {
        show: true,
      },
      y: {
        title: {
          formatter: (seriesName) => seriesName + ":",
        },
        style: {
          fontSize: '16px',
          fontFamily: "Kanit",
          fontWeight: 300,
        },
        formatter: function (val) {
          return val;
        },
      },
      marker: {
        show: true,
      },
      items: {
        display: "flex",
      },
      fixed: {
        enabled: false,
        position: 'topRight',
        offsetX: 0,
        offsetY: 0,
      },
    },
    fill: {
      opacity: 1,
      // type: ['solid', 'gradient'],
      // colors: '#F0F0F0'
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          show: false
        }
      }
    }],
    legend: {
      show: false,
      position: "right",
      offsetY: 0,
      height: 200,
      // horizontalAlign: "left",
      // offsetX: -33,
      // offsetY: -55,
      formatter: function (val, opts) {
        const roundToHundred = (arr) => {
          let output = [];
          let acc = 0;
          for (let i = 0; i < arr.length; i++) {
            let roundedCur = Math.round(arr[i][0]);
            const currentAcc = acc;
            if (acc == 0) {
              output.push(roundedCur);
              acc += arr[i][0];
              continue;
            }
            acc += arr[i][0];
            output.push(Math.round(acc) - Math.round(currentAcc));
          }
          return output;
        };
        let roundedVal = roundToHundred(opts.w.globals.seriesPercent);
        return (
          "<span class='fs-12px ml-2'>" +
          (val ? val : "-") +
          ":</span><span class='fs-12px fw-600 float-right ml-1'>" +
          (opts.w.globals.series[opts.seriesIndex] ? opts.w.globals.series[opts.seriesIndex] : 0) +
          " (" + (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0) + "%)" +
          "</span>"
        );
      },
    },
  })
  const [categoryRatio, setCategoryRatio] = React.useState([])
  const [approvalData, setApprovalData] = React.useState({ goal_list: [] })
  const [goalList, setGoalList] = React.useState({ goal_list: [], total: 0 })
  const [weightSeries, setWeightSeries] = React.useState([])
  const [ratio, setRatio] = React.useState(0)
  const [filterCheckbox, setFilterCheckbox] = React.useState({
    selectAll: false,
    draft: true,
    new: true,
    update: true,
    pending: true,
    approved: true,
    pending_delete: true,
  })
  const [checkbox, setCheckbox] = React.useState([true, true, true, true, true, true, false]);
  const [goalDetailData, setGoalDetailData] = React.useState(null)
  const [serialDetail, setSerialDetail] = React.useState(null)
  const [checkboxStatus, setCheckboxStatus] = React.useState("all");
  const [statusForm, setStatusForm] = React.useState({})
  const [goalProgressMockup, setGoalProgressMockup] = React.useState({})
  const [loadApex, setLoadApex] = React.useState(true)
  const [kpiFormId, setKpiFormId] = React.useState("")
  const [serialGoalAssign, setSerialGoalAssign] = React.useState("")
  const [isUpdateDialogOpen, openUpdateDialog] = React.useState(false);
  const [targetValue, setTargetValue] = React.useState(null);
  const [progressValue, setProgressValue] = React.useState(null);
  const [goalDetail, setGoalDetail] = React.useState({});
  const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
  const [serialForUpdate, setSerialForUpdate] = React.useState(null)
  const [workflowEnd, setWorkflowEnd] = React.useState(null)
  const [editOwner, setEditOwner] = React.useState(false)
  const [cycleId, setCycleId] = React.useState(1)
  const [asOfDate, setAsOfDate] = React.useState(Util.formatDate(new Date()));
  const [remark, setRemark] = React.useState("");
  const [goalScaleData, setGoalScaleData] = React.useState([]);
  const [noGoalData, setNoGoalData] = React.useState(false);
  const [hideData, setHideData] = React.useState([]);
  const [undeleteList, setUndeleteList] = React.useState([]);
  const [isEvaluator, setIsEvaluator] = React.useState(false);
  const [ownerInfo, setOwnerInfo] = React.useState(null)
  const [workflowAssign, setWorkflowAssign] = React.useState(null)
  // Variable End

  // Function Start
  const acceptConsent = (data) => {
    navigate(data, { replace: false });
  }
  const handleChangeTabs = (_, val) => {
    if (val) setWorkloadTypeSelected(val);
    setValueTab(val);
  };
  const handleClick = (event, data) => {
    setGoalDetailData(data)
    setSerialDetail(data.serial)
    setAnchorEl(event.currentTarget);
  };
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl2(null);
  };
  const handleOption = (option, data) => {
    setAnchorEl(null);

    data.isEvaluator = isEvaluator
    if (isEvaluator && ownerInfo && ownerInfo?.code) {
      data.owner = ownerInfo
    }
    if (isEvaluator && serial) data.formEvaluateId = serial

    if (option == t('mygoal.label.delete') && data?.progress_status?.description !== 'pending_delete') {
      openConfirmDeleteDialog(true)
      setDeleteSerial(data.serial)
    } else if (option === t('mygoal.label.delete') && data?.progress_status?.description === 'pending_delete') {
      openCancelDeleteDialog(true)
      setDeleteSerial(data.serial)
    } else if (option == t('mygoal.label.viewDetail')) {
      Object.assign(data, { goalSerial: data.serial })
      Object.assign(data, { serial: evaluatorSerial })
      if (data.is_cascaded) {
        Object.assign(data, { sendGoalType: data.type?.code === 'team' ? 2 : data?.type.code === 'personal' ? 3 : 1 })
      }
      Object.assign(data, { statusForm: statusForm })
      Object.assign(data, { workflowEnd: workflowEnd })
      Object.assign(data, { isCreatable: isCreatable })
      Object.assign(data, { backupGoalDetailSerial: serial })
      Object.assign(data, { historyTemplate: workloadFormSelectValue })
      Object.assign(data, { viewSerial: serial })
      Object.assign(data, { isGoalOwner: isOwner })
      Object.assign(data, { isCreatable: isCreatable })
      goto(`mygoal-detail/${serialDetail}`, data)
    } else if (option == t('mygoal.label.edit')) {
      Object.assign(data, { goalSerial: data.serial })
      Object.assign(data, { serial: evaluatorSerial })
      Object.assign(data, { historyTemplate: workloadFormSelectValue })

      if (data.is_cascaded) {
        Object.assign(data, { sendGoalType: data.type?.code === 'team' ? 2 : data?.type.code === 'personal' ? 3 : 1 })
        goto('mygoal-choose-type', data)
      } else {
        goto('mygoal-create/edit', data)
      }
    }
  };
  const handleCloseFailedMessageDialog = (value) => {
    setFailedMessageDialog(false);
  };
  const handleConfirmDeleteList = async () => {
    openConfirmDeleteDialog(false)
    // Delete API
    dispatch(deleteMyGoal(deleteSerial))
      .then(resp => {
        if (resp.success) {
          openSuccessDeleteDialog(true)
          loadDataGoal();
        }
      })
  };
  const handleCancelDeleteList = async () => {
    openCancelDeleteDialog(false)
    // Delete API
    dispatch(putDeleteMyGoal(deleteSerial, { serial: deleteSerial }))
      .then(resp => {
        if (resp.success) {
          openSuccessCancelDeleteDialog(true)
          loadDataGoal();
        }
      })
  };
  const handleConfirmApprove = (val) => {
    openApproveDialog(false);
    const data = {
      kpi_form_goal_assign_id: serialGoalAssign,
    }
    if (val?.remark) data.remark = val.remark
    console.log('handleConfirmApprove', statusForm?.name, workflowAssign)
    //return;
    //postWorkflowSubmit

    if ((statusForm?.name === 'pending' || statusForm?.name === 'pending_cancel') && workflowAssign) {
      data.kpi_workflow_assign_id = workflowAssign

      dispatch(postWorkflowSubmit(data)).then(resp => {
        openSuccessApprovalOpen(true);
        loadDataGoal();
      })

    } else {

      dispatch(postSubmitApproval(data)).then(resp => {
        if (resp.success) {
          openSuccessApprovalOpen(true);
          loadDataGoal();
        }
      })

    }
  }

  const handleConfirmApproveDialog = (val) => {
    openApproveDialog(val);
  }
  const checkApproveData = () => {
    var pointApprove = 0
    approvalData.goal_list.map((item => {
      pointApprove += 100 - sumWeight(item.goal_items)//(item.goal_items.reduce((sum, value) => parseFloat(sum) + parseFloat(value.weight), 0))
    }))
    if (pointApprove === 0) {
      openApproveDialog(true);
    } else {
      showAlertSummary(true);
    }
  }
  const gotoDetail = (data) => {
    Object.assign(data, { goalSerial: data.serial })
    Object.assign(data, { serial: evaluatorSerial })
    Object.assign(data, { statusForm: statusForm })
    Object.assign(data, { workflowEnd: workflowEnd })
    Object.assign(data, { isCreatable: isCreatable })
    Object.assign(data, { backupGoalDetailSerial: serial })
    Object.assign(data, { historyTemplate: workloadFormSelectValue })
    Object.assign(data, { viewSerial: serial })
    Object.assign(data, { isGoalOwner: isOwner })
    Object.assign(data, { isCreatable: isCreatable })
    if (data.is_cascaded) {
      Object.assign(data, { sendGoalType: data.type?.code === 'team' ? 2 : data?.type.code === 'personal' ? 3 : 1 })
    }
    goto(`mygoal-detail/${data.goalSerial}`, data)
  }
  const gotoSeeAll = (item) => {
    Object.assign(item, { evaluatorSerial: evaluatorSerial })
    Object.assign(item, { statusForm: statusForm })
    Object.assign(item, { workflowEnd: workflowEnd })
    Object.assign(item, { isCreatable: isCreatable })
    Object.assign(item, { backupGoalDetailSerial: serial })
    Object.assign(item, { historyTemplate: workloadFormSelectValue })
    Object.assign(item, { viewSerial: serial })
    goto('mygoal-list', item)
  }
  const gotoCreateGoal = (code) => {
    let data = {
      serial: evaluatorSerial,
      kpiFormId: kpiFormId,
      cycle_id: cycleId,
      defaultCategory: code ?? undefined,
      historyTemplate: workloadFormSelectValue,
      isEvaluator,
    }

    if (isEvaluator && ownerInfo && ownerInfo?.code) {
      data.owner = ownerInfo
    }

    if (isEvaluator && serial) data.formEvaluateId = serial

    goto('mygoal-choose-create', data);
  }
  const goto = (route, data) => {
    if (route) {
      if (route === 'mygoal' && state.isEvaluator && state.formEvaluateId) route += '/' + state.formEvaluateId
      route = '/' + route
    }

    if (data) {
      navigate("/kpi" + route, { replace: false, state: data });
    } else {
      navigate("/kpi" + route, { replace: false });
    }
  }
  const openApproveSummary = () => {
    setApproveSummary(!approveSummary)
  }
  const onCloseAlertDialog = () => {
    setTitle("")
    setMessage("")
    setColor("")
    setTypeAlertDialog("")
    setColorHover("")
    setSize("")
    openAlertDialogOpen(false)
  }
  const handleConfirmDeleteDialog = (val) => {
    openConfirmDeleteDialog(val)
  };
  const handleCancelDeleteDialog = (val) => {
    openCancelDeleteDialog(val)
  };
  const handleCheckbox = (data) => {
    let tmp = [...checkbox]
    let filterCheck = { ...filterCheckbox }
    if (data === "all") {
      if (checkboxStatus === "indeterminate") {
        tmp = tmp.map(item => item = true)
        filterCheck.selectAll = true
      } else if (checkboxStatus === "all") {
        tmp = tmp.map(item => item = false)
        filterCheck.selectAll = false
        filterCheck.approved = false
        filterCheck.draft = false
        filterCheck.new = false
        filterCheck.pending = false
        filterCheck.pendingDelete = false
        filterCheck.update = false
      } else if (checkboxStatus === "none") {
        tmp = tmp.map(item => item = true)
        filterCheck.selectAll = true
      }
    } else if (data === "draft") {
      tmp[0] = !tmp[0]
      filterCheck.draft = tmp[0]
    } else if (data === "new") {
      tmp[1] = !tmp[1]
      filterCheck.new = tmp[1]
    } else if (data === "update") {
      tmp[2] = !tmp[2]
      filterCheck.update = tmp[2]
    } else if (data === "pending") {
      tmp[3] = !tmp[3]
      filterCheck.pending = tmp[3]
    } else if (data === "approved") {
      tmp[4] = !tmp[4]
      filterCheck.approved = tmp[4]
    } else if (data === "pending_delete") {
      tmp[5] = !tmp[5]
      filterCheck.pending_delete = tmp[5]
    }
    setCheckbox(tmp);
    setFilterCheckbox(filterCheck)
  };

  const checkCheckboxStatus = () => {
    let countChecked = 0
    let result = "none"
    let filterCheck = { ...filterCheckbox }
    checkbox.forEach(item => {
      if (item) countChecked++
    })
    if (countChecked === checkbox.length) {
      result = "all"
      filterCheck.selectAll = true;
    } else if (countChecked > 0 && countChecked < checkbox.length) {
      result = "indeterminate"
      filterCheck.selectAll = false;
    }
    setCheckboxStatus(result);
    setFilterCheckbox(filterCheck)
  }

  const upperFirstWord = (str) => {
    if (str) {
      var splitStr = str.toString().toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(' ');
    }
  }

  const checkCanSubmitOnApproval = () => {
    let canSubmit = false;
    approvalData.goal_list.map((item) => {
      let sum = sumWeight(item.goal_items);
      //sum = sumBy(item.goal_items, (o) => { return o.weight * 1 });
      //sum = Math.round(sum * 100) / 100;
      if (sum !== 100 || approvalData?.is_submitable === false) {
        canSubmit = true;
      }
    })
    if (workflowEnd) {
      canSubmit = workflowEnd;
    }
    return canSubmit;
  }

  const convertStringToDate = (dataDate) => {
    if (dataDate) {
      const dateTimeSplit = dataDate?.split(' ');
      const date = dateTimeSplit[0].split('/')

      return dayjs(`${date[1]}/${date[0]}/${date[2]} ${dateTimeSplit[1]}`).locale(i18n.language === "th-TH" ? 'th' : 'en').format('DD MMM YYYY (HH:mm)')
    } else {
      return null
    }
  }

  const statusBox = (data, isCenter) => {
    if (data == 'new') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.new')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'approved' || data?.name == 'approved') {
      return (
        <Box style={{ backgroundColor: '#5DA1961A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is approved'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#5DA196" style={{ cursor: 'default' }}>
              {t('label.status.approve')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (
      data == 'pending_delete' || data == 'pending delete' || data?.description === 'pending_delete'
    ) {
      return (
        <Box style={{ backgroundColor: '#CC60581A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is awaiting approval for deletion.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#CC6058" style={{ cursor: 'default' }}>
              {t('label.status.pendingDelete')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (
      data == 'pending_cancel' || data?.name == 'pending_cancel' || data?.description === 'pending_cancel'
    ) {
      return (
        <Box style={{ backgroundColor: '#CC60581A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is awaiting approval for adjustment.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#CC6058" style={{ cursor: 'default' }}>
              {t('label.status.cancelRequest')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'pending' || data?.name == 'pending') {
      return (
        <Box style={{ backgroundColor: '#F280261A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is waiting for approved.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#F28026" style={{ cursor: 'default' }}>
              {t('label.status.pending')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'update') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal updates already and has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.update')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else {
      return (
        <Box style={{ backgroundColor: data?.color?.background, width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: (data?.name === 'ยังไม่ได้ดำเนินการ' || data?.name === 'Not Started') ? '1px solid #DADADA4A' : `0px` }}>
          <Typography fontSize={16} lineHeight="21px" fontWeight="500" color={data?.color?.font}>
            {/* {upperFirstWord(data?.name)} */}
            {data?.name == 'in progress' ? t('label.status.inProgress') : data?.name === 'Not Started' ? t('label.status.notStart') : upperFirstWord(data?.name)}
          </Typography>
        </Box>
      )
    }
  }
  // Function End

  useEffect(() => {
    checkCheckboxStatus()
  }, [checkbox])

  useEffect(async () => {
    loadCycle(serial ?? null)
    if (serial) {
      setIsOwner(false)
      setAllowAdjust(false)
      setIsEvaluator(false)
    }
    // setWorkloadForm([{name: 'Performance Evaluation of 2022', value:'2022'}])
    // setWorkloadFormValue('2022')
  }, []);

  const loadCycle = (serial) => {
    dispatch(getGoalCycle(serial ?? null))
      .then(resp => {
        if (resp.data.length > 0) {
          setWorkloadForm(resp.data)
          if (state?.historyTemplate) {
            setWorkloadFormValue(state?.historyTemplate)
            let findSerial = resp.data.find((item) => item.options.serial === state?.historyTemplate)?.options?.serial
            loadDataGoal(findSerial);
          } else {
            setWorkloadFormValue(resp.data[0].options?.serial)
            loadDataGoal(resp.data[0].options?.serial);
          }
        } else {
          setNoGoalData(true)
        }
      })
  }

  const loadDataGoal = (cycle) => {
    dispatch(getGoalList(cycle ?? workloadFormSelectValue))
      .then(resp => {
        formatData(resp)
      })
  }

  const setDataForUpdateDialog = (data) => {
    setTargetValue("")
    setRemark("")
    openUpdateDialog(true);
    setSerialForUpdate(data.serial)
    setConditionBackup(data.target_condition)
    dispatch(getMyGoalDetail(data.serial))
      .then(resp => {
        setGoalDetail(resp.data)
        if ((resp?.data?.goal_progress?.goal_metric?.description === 'Date' || resp?.data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date') && resp?.data?.goal_progress?.actual_value !== '') {
          var splitValue = resp?.data?.goal_progress?.actual_value?.split('/')
          var target = splitValue[1] + "/" + splitValue[0] + "/" + splitValue[2]
          setTargetValue(target || null)
        } else {
          var date = null
          if (resp?.data?.goal_progress?.actual_value === '' && (resp?.data?.goal_progress?.goal_metric?.description === 'Date' || resp?.data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date')) {
            date = dayjs().format('MM/DD/YYYY')
          } else {
            date = resp?.data?.goal_progress?.actual_value || null
          }
          setTargetValue(date)
        }
        setProgressValue(resp?.data?.goal_progress?.goal_progress_data?.serial)
        setEditOwner(resp?.data?.is_owner)
      })
    dispatch(getMyGoalProgress(data.serial))
      .then(resp => {
        if (resp.success)
          setGoalProgressOption(resp.data.goal_progress_data)
        setGoalScaleData(resp.data.goal_progress.scale_level_current)
      })
  }

  const handleClearClick = () => {
    setTargetValue(null)
  }

  const updateGoal = () => {
    openUpdateDialog(false);
    // openSuccessAddDialog(true);
    // Do API here /goals/${id}/progress

    let target = targetValue;
    if (targetValue && targetValue.indexOf('/') > 0) {
      var splitValue = target.split('/')
      target = splitValue[1] + "/" + splitValue[0] + "/" + splitValue[2]
    }

    const sendData = {
      goal_id: goalDetail?.goal?.serial,
      target_value: target,
      goal_progress_data: progressValue,
      remark: remark,
      date: asOfDate
    }

    dispatch(putUpdateProgress(goalDetail?.goal?.serial, sendData))
      .then((resp) => {
        if (resp.success) {
          dispatch(getMyGoalDetail(serialForUpdate))
            .then(resp => {
              setGoalDetail(resp.data)
              setTargetValue(resp.data.goal_progress.actual_value || null)
              loadDataGoal();
            })
        }
        openSuccessAddDialog(true);
      })
  }

  const handleCloseDialog = () => {
    openUpdateDialog(false);
  };

  const formatData = (data) => {
    setKpiFormId(data?.data?.kpi_form.serial);
    setCycleId(data?.data?.kpi_form.cycle_id);
    if (data?.data?.kpi_form?.form_evaluate_data === null || data?.data?.kpi_form?.form_evaluate_data === undefined || Object.keys(data?.data?.kpi_form?.form_evaluate_data).length === 0) {
      setNoGoalData(true)
    } else if (data?.data?.kpi_form?.form_evaluate_data) {
      setNoGoalData(false)
      const kpiForm = data.data.kpi_form.form_evaluate_data[0];
      //if ((kpiForm?.approval_summary?.is_owner) && (serial === null || serial === undefined)) {
      //}

      setIsOwner(kpiForm.approval_summary?.is_owner || false)

      setAllowAdjust(kpiForm.approval_summary?.allow_adjust || false)
      setIsEvaluator(kpiForm.approval_summary?.is_evaluator || false)

      if (data.data?.owner) setOwnerInfo(data.data.owner)

      setIsCreatable(kpiForm.approval_summary.is_creatable)
      //console.log('kpiForm', kpiForm)
      if (kpiForm?.proxy_by ?? false) setProxyBy(kpiForm.proxy_by)
      if (kpiForm?.submitted_by ?? false) setSubmittedBy(kpiForm.submitted_by)
      if (kpiForm?.remark ?? false) setCurrentRemark(kpiForm.remark)


      setWorkflowEnd(kpiForm?.is_workflow_end)
      const formStatus = data.data.kpi_form.form_status
      if (formStatus !== undefined && formStatus !== null && Object.keys(formStatus).length > 0) {
        if (formStatus?.name === 'in progress') {
          var mockupTest = {
            color: "{\"font\": \"#EFB76d\",\"background\": \"#fff5eb\"}",
            name: "in progress"
          }
          mockupTest.color = JSON.parse(mockupTest?.color)
          setStatusForm(mockupTest)
        } else {
          if (formStatus === 'approved' || formStatus.name === 'approved') {
            setApproveSummary(false)
          }
          setStatusForm(formStatus)
        }
      }
      else {
        var mockupTest = {
          color: "{\"font\": \"#EFB76d\",\"background\": \"#fff5eb\"}",
          name: "in progress"
        }
        mockupTest.color = JSON.parse(mockupTest?.color)
        setStatusForm(mockupTest)
      }
      kpiForm.approval_summary.goal_list = kpiForm.my_goal_list.goal_list_approval_summary //my_goal_list.goal_list_approval_summary
      setApprovalData(kpiForm.approval_summary)
      setCategoryRatio(kpiForm.goal_category_evaluate_ratio)
      setGoalList(kpiForm.my_goal_list)
      setGoalProcess(kpiForm.goal_progress)
      setRatio(kpiForm.ratio)
      setEvaluatorSerial(kpiForm.serial)
      setSerialGoalAssign(kpiForm.serial_goal_assign)
      setWorkflowAssign(kpiForm?.workflow_assign ?? null)

      if (kpiForm.my_goal_list?.goal_list[0]?.goal_items[0]?.progress_status == undefined || kpiForm.my_goal_list?.goal_list[0]?.goal_items[0]?.progress_status == null ||
        Object.keys(kpiForm.my_goal_list?.goal_list[0]?.goal_items[0]?.progress_status).length == 0) {
        var mockupProgress = {
          code: "not_started",
          color: "{\"font\": \"#DADADA\", \"background\": \"#FFFFFF\"}",
          is_default: true,
          name: "Not Started",
          seq: 1,
          serial: "bfaeaf1f-f5ad-4ddb-b02d-624f05d16da0"
        }
        mockupProgress.color = JSON.parse(mockupProgress.color)
        setGoalProgressMockup(mockupProgress)
      }
      var colorWeight = [];

      const weightChart = kpiForm.goal_category_evaluate_ratio.map((item) => {
        colorWeight.push(item.color)
        return {
          name: item.name,
          data: [parseInt(item.weight)]
        }
      })

      var weightObjectData = { ...weightObject }

      weightObjectData.colors = colorWeight;

      var chartColor = [];

      kpiForm.goal_progress.more_data.map((item) => {
        chartColor.push(JSON.parse(item.color).font)
      })

      var chartObjectData = { ...chartObject }
      chartObjectData.colors = chartColor;
      chartObjectData.labels = kpiForm.goal_progress.Graph.data.name;
      const datas = {
        value: kpiForm.goal_progress.Graph.data.value,
        total: kpiForm.goal_progress.total_goal,
      }
      chartObjectData.plotOptions.pie.donut.labels.total.formatter = (w) => {
        return `${parseFloat(w.globals.seriesPercent[w.globals.seriesPercent.length - 1]).toFixed(1)}%`
      };
      setChartObject(chartObjectData)
      setLoadApex(false);
      setWeightObject(weightObjectData)
      setWeightSeries(weightChart)


      const customDataHide = data.custom?.data_hide?.configuration || {}
      if (customDataHide) {
        let goals = filter(customDataHide, { module: 'goal' })
        setHideData(goals)
      }


      const customUndelete = data.custom?.goal_undelete?.configuration || []
      if (customUndelete) {
        //setUndeleteList(customUndelete)
      }

    }
  }


  const sumWeight = (goal_items) => {
    //return goal_items.reduce((sum, value) => parseFloat(sum) + parseFloat(value.weight), 0)
    let totalWeight = 0

    totalWeight = sumBy(goal_items, (o) => { return o.weight * 1 })
    totalWeight = Math.round(totalWeight * 100) / 100

    return totalWeight
  }


  // ----------------------------------
  const useStyles = makeStyles({
    clipPath: 'inset(0% 0% -2px 0% round 2px)',
    root: {
      fontSize: "16px",
    },
    plusSvg: {
      "& > path": {
        fill: "#fff",
        stroke: "#fff",
      }
    },
    inactiveSvg: {
      "& > path": {
        fill: "#D0D0D0"
      },
      '& g > path': {
        fill: '#D0D0D0'
      },
    },
    statusGraph: {
      "& > path": {
        fill: "#fff"
      }
    },
    internalIcon: {
      "& > path": {
        fill: "#fff"
      },
      '& g > path': {
        fill: '#fff'
      },
    },
    linkIcon: {
      "& > path": {
        fill: "#A0A0A0"
      },
      '& g > path': {
        fill: '#A0A0A0'
      },
    },
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },
    clickable: {
      cursor: "pointer",
      transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      '&:hover': {
        color: 'rgb(65, 112, 105) !important'
      }
    },
    fillDisable: {
      '& > path': {
        fill: '#A0A0A0'
      },
      '& g > path': {
        fill: '#A0A0A0'
      },
    },
    btn: {
      '& > svg': {
        marginLeft: "10px"
      },
    },
  });
  const classes = useStyles();
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
    tab: {
      width: '20px', // a number of your choice
    }
  };

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));

  const convertDateFormat = (list) => {
    if (list.metric.description == 'Date') {
      return (
        <Typography fontSize={18} lineHeight="21px" fontWeight={400} color="#404349">
          {`${list.target_value ? `${list.target_value} ${list.unit?.description || ''}` : '-'}`}
        </Typography>
      )
    } else {
      return (
        <Typography fontSize={18} lineHeight="21px" fontWeight={400} color="#404349">
          {`${list.target_value ? `${list.target_value} ${list.unit?.description || ''}` : '-'}`}
        </Typography>
      )
    }
  }

  const handleAdjust = (val) => {
    setOpenAdjust(false)

    const data = {
      kpi_form_goal_assign_id: serialGoalAssign,
      type: 'adjust',
      remark: val.description,
    }
    dispatch(postSubmitApproval(data)).then(resp => {
      if (resp.success) {
        openSuccessApprovalOpen(true);
        loadDataGoal();
      }
    })

    console.log('handleAdjust', data)
  }

  const getLabelTitle = () => {
    let title = t('mygoal.label.title')

    if (isEvaluator && ownerInfo?.code) {
      title = ownerInfo.firstname + ' ' + ownerInfo.lastname
      title += '\'s ' + t('label.goal')
    }

    return title
  }

  return (
    <Box style={{ "max-height": "100%", "overflow-y": "auto" }}>
      <Box id="back-to-top-anchor"> </Box>
      <Helmet>
        <title>{getLabelTitle()}</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minheight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => acceptConsent('/kpi/home')}>
                {t('label.home')}
              </span> / &nbsp;
              <span style={styles.end} >
                {getLabelTitle()}
              </span>
            </Typography>
          </Grid>
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          {noGoalData
            ?
            <Grid>
              <Grid container direction="row">
                <Grid item >
                  <Typography variant="h1" fontSize={36} lineHeight="39.6px" fontWeight="500" color="#404349">
                    {getLabelTitle()}
                  </Typography>
                </Grid>
              </Grid>
              {workloadFormSelect.length > 0 &&
                <Grid container my={3}>
                  <Grid item md={6} pr={1}>
                    <Select
                      id="workload-select"
                      inputlabelprops={{ shrink: false }}
                      variant="outlined"
                      size="small"
                      className="white-bg"
                      value={workloadFormSelectValue}
                      onChange={handleChangeWorkloadForm}
                    >
                      {
                        workloadFormSelect?.length > 0 ?
                          workloadFormSelect.map((item, idx) => {
                            return (
                              <MenuItem value={`${item.options.serial}`} key={`${item.options.serial}-${idx}`}>
                                {item.name}
                              </MenuItem>
                            )
                          })

                          : <MenuItem value="">
                            {t("mygoal.label.notFound")}
                          </MenuItem>
                      }
                    </Select>
                  </Grid>
                </Grid>
              }
              <Grid item lg={12} xs={12} style={{ textAlign: 'center', paddingTop: '25vh' }}>
                <Box>
                  <img src={fileBrowser} alt="browser" />
                </Box>
                <Box>
                  <Typography variant="sub_label" color="#A0A0A0">{t("mygoal.label.noData")}</Typography>
                </Box>
              </Grid>
            </Grid>
            :
            <Grid>
              <Grid container direction="row">
                <Grid item >
                  <Typography variant="h1" fontSize={36} lineHeight="39.6px" fontWeight="500" color="#404349">
                    {getLabelTitle()}
                  </Typography>
                </Grid>
                <Grid item ml={2}>
                  {statusBox(statusForm || 'new')}
                </Grid>
              </Grid>
              {isOwner &&
                <Grid container my={3}>
                  <Grid item md={6} pr={1}>
                    <Select
                      id="workload-select"
                      inputlabelprops={{ shrink: false }}
                      variant="outlined"
                      size="small"
                      className="white-bg"
                      value={workloadFormSelectValue}
                      onChange={handleChangeWorkloadForm}
                    >
                      {
                        workloadFormSelect?.length > 0 ?
                          workloadFormSelect.map((item, idx) => {
                            return (
                              <MenuItem value={`${item.options.serial}`} key={`${item.options.serial}-${idx}`}>
                                {item.name}
                              </MenuItem>
                            )
                          })

                          : <MenuItem value="">
                            {t("mygoal.label.notFound")}
                          </MenuItem>
                      }
                    </Select>
                  </Grid>
                  {/* <Grid
                    item
                    md={6}
                    display="flex"
                    alignItems="flex-end"
                    flexDirection="row-reverse"
                  >
                    <Box style={{marginLeft: 10}}>
                      <Button
                        size="small"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={() => {}}
                        color="black"
                        variant="outlined"
                        style={{textTransform: 'none'}}
                        disabled={!fullVersion}
                      >
                        <SeeChartIcon width={15} height={15} className={fullVersion ? {} : classes.inactiveSvg} />
                        <Typography ml={1}>{t("mygoal.label.viewChart")}</Typography>
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        size="small"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={() => {}}
                        color="black"
                        variant="outlined"
                        style={{textTransform: 'none'}}
                        disabled={!fullVersion}
                      >
                        <ExportIcon width={15} height={15} className={fullVersion ? {} : classes.inactiveSvg} />
                        <Typography ml={1}>{t("mygoal.label.exportReport")}</Typography>
                      </Button>
                    </Box>
                  </Grid> */}
                </Grid>
              }
              <Grid container spacing={4} mt={isOwner ? 3 : 0}>
                <Grid lg={6} xs={12} item>
                  <Card style={{ height: '100%', borderRadius: '10px' }} elevation={2}>
                    <CardContent>
                      <Grid lg={12} xs={12} container>
                        <Grid
                          item
                          lg={6}
                          xs={12}
                          display="flex"
                          alignItems="center"
                          textAlign="left"
                        >
                          <Grid item style={{ padding: '10px', marginRight: 10, backgroundColor: "#F28026", width: '40px', height: '40px', borderRadius: 5 }}>
                            <StatusGraphIcon style={{ width: 20, height: 20 }} className={classes.statusGraph} />
                          </Grid>
                          <Grid item>
                            <Typography fontSize={18} lineHeight="21px" fontWeight="500" color="#404349">
                              {t("mygoal.label.goalProgress")}
                            </Typography>
                            <Typography fontWeight="fontWeightLight" fontSize={12} variant="label">
                              {t("mygoal.label.dateAsOf")}{dayjs(goalProcess.date_as_of).locale(i18n.language === "th-TH" ? 'th' : 'en').format('DD MMM YYYY')}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                      <Grid container lg={12} xs={12} mb={3}>
                        <Grid lg={12} xs={12} alignItems="right" justifyContent="right" textAlign="right">
                          <Typography fontWeight="fontWeightLight" fontSize={12} variant="label">
                            {t("mygoal.label.totalGoal")} {goalProcess.total_goal} {t("mygoal.label.goalUnit")}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container lg={12} xs={12} direction="row">
                        <Grid item lg={4.5} xs={12}>
                          <Box sx={{ "margin-left": "-10px", ".apexcharts-tooltip-y-group > span": { "font-weight": "400" }, ".apexcharts-active": { background: "#F7F7F7", "padding-bottom": "0px", "box-shadow": "0px 2px 4px rgba(0, 0, 0, 0.15)", ".apexcharts-tooltip-marker": { "border-radius": "unset", "border-radius": "2px" } }, ".apexcharts-graphical": { transform: "unset" } }}>
                            {loadApex == false &&
                              (goalProcess.Graph.data.value.some((item) => item != '0') &&
                                <Chart options={chartObject} series={goalProcess.Graph.data.value} type="donut" />
                              )
                            }
                            {loadApex == false &&
                              goalProcess.Graph.data.value.every((item) => item == '0') &&
                              <Chart options={emptyObject} series={emptySeries} type="donut" />
                            }
                          </Box>
                        </Grid>
                        <Grid container lg={7.5} xs={12} direction="row">
                          {goalProcess.more_data.map((item, key) => {
                            return (
                              <Grid key={key} item lg={5.2} mr={3} sx={{ border: `0.5px solid #DADADA`, borderLeftColor: `${JSON.parse(item.color).font}`, borderLeftWidth: 7, borderRadius: 2, padding: '8px 15px 8px 15px', maxHeight: '55px', color: JSON.parse(item.color).font }}>
                                <Grid container direction="row">
                                  <Grid lg={8} xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography fontSize={12} color="#888888" fontWeight={400} style={{ paddingTop: '5px' }}>
                                      {item.name}
                                    </Typography>
                                  </Grid>
                                  <Grid lg={4} xs={12} style={{ textAlign: 'right' }}>
                                    <Typography fontWeight="bold" fontSize={24} variant="label" color={item.color.font}>
                                      {goalProcess.Graph.data.value[key] || 0}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )
                          })}
                        </Grid>

                        {/* <Grid container lg={3} xs={12} direction="row" style={{display: 'grid'}}>
                          {goalProcess.more_data.map((item, key) => {
                            if(key < 3) {
                              return (
                                <Grid key={key} item lg={12} xs={6} sx={{border: `0.5px solid #DADADA`, borderLeftColor: `${JSON.parse(item.color).font}`, borderLeftWidth: 7, borderRadius: 2, padding: '8px 15px 8px 15px', maxHeight: '55px', color: JSON.parse(item.color).font}}>
                                  <Grid container direction="row">
                                    <Grid lg={8} xs={12} style={{display: 'flex', alignItems: 'center'}}>
                                      <Typography fontSize={12} color="#888888" fontWeight={400}>
                                        {item.name} 
                                      </Typography>
                                    </Grid>
                                    <Grid lg={4} xs={12} style={{textAlign: 'right'}}>
                                      <Typography fontWeight="bold" fontSize={24} variant="label" color={item.color.font}>
                                        {goalProcess.Graph.data.value[key] || 0}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )
                            }
                          })}
                        </Grid>
                        <Grid container lg={0.5} />
                        {goalProcess.more_data?.length > 3 &&
                        <Grid container lg={3} xs={12} direction="row" style={{display: 'grid'}} pl={1}>
                          {goalProcess.more_data.map((item, key) => {
                            if(key >= 3) {
                              return (
                                <Grid key={key} item lg={12} xs={6} sx={{border: `0.5px solid #DADADA`, borderLeftColor: `${JSON.parse(item.color).font}`, borderLeftWidth: 7, borderRadius: 2, padding: '8px 15px 8px 15px', maxHeight: '55px', color: JSON.parse(item.color).font}}>
                                  <Grid container direction="row">
                                    <Grid lg={8} xs={12} style={{display: 'flex', alignItems: 'center'}}>
                                      <Typography fontSize={12} color="#888888" fontWeight={400}>
                                        {item.name} 
                                      </Typography>
                                    </Grid>
                                    <Grid lg={4} xs={12} style={{textAlign: 'right'}}>
                                      <Typography fontWeight="bold" fontSize={24} variant="label" color={item.color.font}>
                                        {goalProcess.Graph.data.value[key] || 0}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )
                            }
                          })}
                        </Grid>
                        }  */}
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid lg={6} xs={12} item pb={0}>
                  <Card style={{ height: '100%', borderRadius: '10px' }} elevation={2}>
                    <CardContent>
                      <Grid lg={12} xs={12} container>
                        <Grid
                          item
                          lg={12}
                          xs={12}
                          display="flex"
                          alignItems="center"
                          textAlign="left"
                        >
                          <Grid item style={{ padding: '10px', marginRight: 10, backgroundColor: "#F28026", width: '40px', height: '40px', borderRadius: 5 }}>
                            <GoalWeightIcon style={{ width: 20, height: 20 }} className={classes.statusGraph} />
                          </Grid>
                          <Grid item>
                            <Typography fontSize={18} lineHeight="21px" fontWeight="500" color="#404349">
                              {t("mygoal.label.categoryWeight")}
                              <BootstrapTooltip
                                placement="right"
                                arrow
                                title={t('mygoal.label.ratio')}
                                style={{ marginLeft: '5px' }}
                              >
                                <TooltipIcon />
                              </BootstrapTooltip>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                      <Grid container lg={12} xs={12}>
                        <Grid item lg={6} xs={12} pt={'2px'}>
                          <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#404349">
                            {t("mygoal.label.categoryRatio")}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container lg={12} xs={12} style={{ maxHeight: '90px !imporatnt' }}>
                        <Grid item lg={12} xs={12}>
                          <Box sx={{ maxHeight: '90px !important', ".apexcharts-tooltip-y-group > span": { "font-weight": "400" }, ".apexcharts-active": { background: "#F7F7F7", "padding-bottom": "0px", "box-shadow": "0px 2px 4px rgba(0, 0, 0, 0.15)", ".apexcharts-tooltip-marker": { "border-radius": "unset", "border-radius": "2px" } }, ".apexcharts-graphical": { transform: "unset" } }}>
                            <Chart options={weightObject} series={weightSeries} type="bar" height="100px" />
                          </Box>
                        </Grid>
                      </Grid>
                      {categoryRatio.map((item, key) => {
                        return (
                          <Grid key={key} container lg={12} xs={12} direction="row">
                            <Grid item mt={'6px'} style={{ marginRight: '5px' }}>
                              <Box style={{ backgroundColor: `${item.color}`, width: 10, height: 10, borderRadius: 5 }}></Box>
                            </Grid>
                            <Grid item lg={10} xs={12}>
                              <Typography fontSize={14} variant="label" fontWeight="300" ml={'15px'}>
                                {item.name} ({`${item.weight}%`})
                              </Typography>
                            </Grid>
                          </Grid>
                        )
                      })}
                      <Divider style={{ marginTop: 45, marginBottom: 25 }} />
                      <Grid container direction="row" alignItems="right" justifyContent="flex-end" textAlign="right" style={{ justifyContent: 'flex-end' }}>
                        <Grid xs={2} item mt={'1px'}>
                          <Typography fontWeight="500" fontSize={18} color="#404349">
                            {t("mygoal.label.total")}
                          </Typography>
                        </Grid>
                        <Grid xs={1} item>
                          <Typography fontWeight="500" fontSize={20} style={{ color: 'rgb(93, 161, 150)' }}>
                            {ratio}%
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid container spacing={4} mt={3}>
                <Grid
                  item
                  lg={6}
                  xs={12}
                  display="flex"
                  alignItems="center"
                  textAlign="left"
                >
                  <Grid item style={{ marginRight: 10, cursor: 'pointer', backgroundColor: 'white', border: '1px solid #DADADA' }} onClick={() => { openApproveSummary() }}>
                    {approveSummary
                      ?
                      <Icon style={{ color: '#6B6B6B', fontSize: 45, paddingTop: '4px' }}>{'keyboard_arrow_down'}</Icon>
                      :
                      <Icon style={{ color: '#6B6B6B', fontSize: 45, paddingTop: '4px' }}>{'chevron_right'}</Icon>
                    }

                  </Grid>
                  <Grid item style={{ cursor: 'pointer' }} onClick={() => { openApproveSummary() }}>
                    <Typography variant="h1" fontSize={30} lineHeight="33px" fontWeight="500" style={{ paddingBottom: '5px' }} color="#404349">
                      {t("mygoal.label.approveSummary")}
                    </Typography>
                    <Typography fontSize={14} fontWeight="fontWeightLight" variant="label">
                      {t("mygoal.label.approveSub")}
                    </Typography>
                  </Grid>
                </Grid>
                {isOwner &&
                  <Grid
                    item
                    lg={4}
                    md={12}
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    display="flex"
                  >
                    {(approvalData?.is_submitable === false && approvalData?.submited_date) &&
                      <Grid container direction="column" justifyContent="flex-end" alignItems="flex-end">
                        <Grid>
                          <Typography style={{ color: '#5DA196', fontSize: '16px', fontWeight: '500', marginRight: '30px', alignSelf: 'center', marginTop: '13px' }}>
                            {`${t('mygoal.label.lastSubmit')} ${approvalData?.submited_date}`}
                          </Typography>
                        </Grid>
                        {submittedBy &&
                          <Grid>
                            <Typography style={{ color: '#5DA196', fontSize: '16px', fontWeight: '500', marginRight: '30px', alignSelf: 'center' }}>
                              {`${t('mygoal.label.submittedBy')}`} {submittedBy}
                            </Typography>
                          </Grid>
                        }
                        {proxyBy &&
                          <Grid>
                            <Typography style={{ color: '#5DA196', fontSize: '16px', fontWeight: '500', marginRight: '30px', alignSelf: 'center' }}>
                              {`${t('mygoal.label.proxyBy')}`} {proxyBy}
                            </Typography>
                          </Grid>
                        }
                      </Grid>
                    }
                  </Grid>
                }
                {isOwner &&
                  <Grid
                    item
                    lg={2}
                    md={12}
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    display="flex"
                    style={{ paddingLeft: '0px' }}
                  >

                    {allowAdjust ? (

                      <Button
                        size="small"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={() => setOpenAdjust(true)}
                        color="primary"
                        variant="contained"
                        style={{ textTransform: 'none', height: '45px' }}
                      >
                        <SubmitButton className={classes.plusSvg} />
                        <Typography ml={1} style={{ color: "white", fontSize: '18px', fontWeight: 500 }}>
                          {t("mygoal.label." + (isEvaluator ? 'adjustBtn' : 'requestAdjustBtn'))}
                        </Typography>
                      </Button>

                    ) : (

                      <Button
                        size="small"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={() => checkApproveData()}
                        color="primary"
                        variant="contained"
                        disabled={checkCanSubmitOnApproval()}
                        style={{ textTransform: 'none', height: '45px' }}
                      >
                        <SubmitButton className={classes.plusSvg} />
                        <Typography ml={1} style={{ color: "white", fontSize: '18px', fontWeight: 500 }}>
                          {t("mygoal.label." + (isEvaluator ? 'submitAndApproveBtn' : 'approveBtn'))}
                        </Typography>
                      </Button>
                    )}

                  </Grid>
                }
                {approveSummary &&
                  <Grid lg={12} xs={12} item>
                    <Card>
                      <CardContent>
                        <Grid lg={12} xs={12} container>
                          <Grid
                            item
                            lg={4}
                            xs={12}
                            display="flex"
                            alignItems="center"
                            textAlign="left"
                          >
                            <Grid item direction="row">
                              <Typography fontSize={16} lineHeight="21px" fontWeight="500" style={{ marginLeft: '20px' }} color="#A0A0A0">
                                {t("mygoal.label.goalItem")}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            lg={1}
                            xs={12}
                            display="flex"
                            alignItems="center"
                            textAlign="right"
                            justifyContent='flex-end'
                          >
                            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#A0A0A0">
                              {t("mygoal.label.weight")}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={1}
                            xs={12}
                            display="flex"
                            alignItems="center"
                            textAlign="right"
                            justifyContent='flex-end'
                          >
                          </Grid>
                          <Grid
                            item
                            lg={2}
                            xs={12}
                            display="flex"
                            alignItems="center"
                            textAlign="center"
                            justifyContent='center'
                          >
                            <Typography fontSize={16} lineHeight="21px" fontWeight="500" style={{ marginRight: '15px' }} color="#A0A0A0">
                              {t("mygoal.label.status")}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={2}
                            xs={12}
                            display="flex"
                            alignItems="center"
                            textAlign="center"
                            justifyContent='center'
                          >
                            <Typography fontSize={16} lineHeight="21px" fontWeight="500" style={{ marginRight: '15px' }} color="#A0A0A0">
                              {t("mygoal.label.goalProgressField")}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            lg={2}
                            xs={12}
                            display="flex"
                            alignItems="center"
                            textAlign="center"
                            justifyContent='center'
                          >
                            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#A0A0A0">
                              {t("mygoal.label.lastUpdate")}
                            </Typography>
                          </Grid>
                        </Grid>
                        {approvalData.goal_list.map((item, key) => {
                          return (
                            <Box key={key}>
                              <Divider style={{ marginTop: 10, marginBottom: 20 }} />
                              <Grid container lg={12} xs={12} onClick={() => { setShowSummary(key) }} style={{ cursor: 'pointer' }}>
                                <Grid lg={4} xs={12} item>
                                  <Grid container direction="row">
                                    <Grid item>
                                      {
                                        showSummary == key
                                          ?
                                          <img src={ArrowBottom} style={{ marginRight: '19px', width: '25px', height: '25px' }} />
                                          :
                                          <img src={ArrowRight} style={{ marginRight: '19px', width: '25px', height: '25px' }} />
                                      }
                                    </Grid>
                                    <Grid item>
                                      <Typography style={{ alignItems: 'center' }} fontWeight="500" fontSize={18} color="#404349">
                                        {item.name}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid lg={1} xs={12}>
                                  <Typography style={sumWeight(item.goal_items) === 100 ? { color: '#5DA196', textAlign: 'right', fontSize: '18px', fontWeight: 500 } : { color: '#CC6058', textAlign: 'right', fontSize: '18px', fontWeight: 500 }}>
                                    {`${sumWeight(item.goal_items)}%`}
                                  </Typography>
                                </Grid>
                              </Grid>
                              <Box style={{ overflowY: item.goal_items.length > 0 ? 'auto' : 'none', maxHeight: '300px', marginTop: '8px' }}>
                                {showSummary == key
                                  ?
                                  item.goal_items.length > 0
                                    ?
                                    item.goal_items.map((list, key) => {
                                      return (
                                        <Grid key={key} container lg={12} xs={12} style={{ alignItems: 'center' }} mt="20px">
                                          <Grid lg={4} xs={12} pl={3}>
                                            <BootstrapTooltip
                                              placement="right"
                                              arrow
                                              title={list.name}
                                              style={{ marginLeft: '5px' }}>
                                              <Typography fontSize={18} lineHeight="29px" fontWeight="400"
                                                style={{ marginLeft: '20px', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2, display: '-webkit-box', overflow: 'hidden' }}
                                                color="#404349">
                                                {list.name}
                                              </Typography>
                                            </BootstrapTooltip>
                                          </Grid>
                                          <Grid lg={1} xs={12}>
                                            <Typography fontSize={18} lineHeight="21px" fontWeight="400" style={{ textAlign: 'right' }} color="#404349">
                                              {`${list.weight}%`}
                                            </Typography>
                                          </Grid>
                                          <Grid lg={1} xs={12}>
                                          </Grid>
                                          <Grid lg={2} xs={12} style={{ textAlign: 'center' }}>
                                            {statusBox(list.goal_status?.description, true)}
                                          </Grid>
                                          <Grid lg={2} xs={12} style={{ textAlign: 'center' }}>
                                            {statusBox(Object.keys(list.progress_status).length > 0 ? list.progress_status : goalProgressMockup, true)}
                                          </Grid>
                                          <Grid lg={2} xs={12}>
                                            <Typography fontSize={18} lineHeight="21px" fontWeight="400" style={{ textAlign: 'center' }} color="#404349">
                                              {list.updated_at}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      )
                                    })
                                    :
                                    <Grid item lg={12} xs={12} style={{ textAlign: 'center', paddingTop: 15, paddingBottom: 50 }}>
                                      <Box>
                                        <img src={fileBrowser} alt="browser" />
                                      </Box>
                                      <Box>
                                        <Typography variant="sub_label" color="#A0A0A0">{t("mygoal.label.noData")}</Typography>
                                      </Box>
                                    </Grid>
                                  :
                                  <Box>

                                  </Box>
                                }
                              </Box>
                            </Box>
                          )
                        })}
                      </CardContent>
                    </Card>
                  </Grid>
                }
              </Grid>
              <Grid lg={12}>
                <Divider style={{ marginTop: '40px', marginBottom: '40px', }} />
              </Grid>
              <Grid container mt={5}>
                <Grid
                  item
                  lg={6}
                  xs={12}
                  display="flex"
                  alignItems="center"
                  textAlign="left"
                >
                  <Grid item style={{ marginRight: 10, backgroundColor: "#F28026", width: '45px', height: '45px', borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <GoalWeightIcon style={{ width: 25, height: 25 }} className={classes.statusGraph} />
                  </Grid>
                  <Grid item>
                    <Typography variant="h1" fontSize={28} fontWeight="500" color="#404349">
                      {t("mygoal.label.myGoalList")}
                    </Typography>
                    <Typography fontSize={14} fontWeight="fontWeightLight" variant="label">
                      {`${t("mygoal.label.totalGoal")} ${goalList.total} ${t("mygoal.label.goalUnit")}`}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={6}
                  md={12}
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  display="flex"
                >
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick2}
                    color="black"
                    variant="outlined"
                    sx={{ marginRight: '30px', height: "45px" }}
                    aria-describedby={id}
                    style={{ textTransform: 'none' }}
                  >
                    <FilterIcon style={{ width: '20px', height: '20px' }} />
                    <Typography ml={1} fontSize="18px" fontWeight="500" color="#404349">{t("mygoal.label.filters")}</Typography>
                  </Button>
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl2}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                  >
                    {checkbox?.length > 0 ?
                      (<Box
                        sx={{
                          p: 1,
                        }}>
                        <Box
                          style={{ "padding-left": "14px", "padding-right": "4px" }}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                          <FormControlLabel
                            style={{ fontSize: '14px' }}
                            label={t("label.selectAll")}
                            control={
                              <Checkbox
                                checked={checkboxStatus === 'all'}
                                indeterminate={checkboxStatus === 'indeterminate'}
                                onChange={() => handleCheckbox("all")}
                                xs={{ pl: 0 }}
                              />
                            }
                          />
                        </Box>
                        {false &&
                          <Box
                            style={{ "padding-left": "12px", "padding-right": "4px" }}
                            sx={{
                              display: "flex",
                              alignItems: "center"
                            }}>
                            <FormControlLabel
                              sx={{ ml: "0!important" }}
                              style={{ fontSize: '14px' }}
                              label={t('label.filter.draft')}
                              control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[0]} onChange={() => handleCheckbox("draft")} />}
                            />
                          </Box>
                        }
                        <Box
                          style={{ "padding-left": "12px", "padding-right": "4px" }}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                          <FormControlLabel
                            sx={{ ml: "0!important" }}
                            style={{ fontSize: '14px' }}
                            label={t('label.filter.new')}
                            control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[1]} onChange={() => handleCheckbox("new")} />}
                          />
                        </Box>
                        <Box
                          style={{ "padding-left": "12px", "padding-right": "4px" }}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                          <FormControlLabel
                            sx={{ ml: "0!important" }}
                            style={{ fontSize: '14px' }}
                            label={t('label.filter.update')}
                            control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[2]} onChange={() => handleCheckbox("update")} />}
                          />
                        </Box>
                        {false &&
                          <Box
                            style={{ "padding-left": "12px", "padding-right": "4px" }}
                            sx={{
                              display: "flex",
                              alignItems: "center"
                            }}>
                            <FormControlLabel
                              sx={{ ml: "0!important" }}
                              style={{ fontSize: '14px' }}
                              label={t('label.filter.pending')}
                              control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[3]} onChange={() => handleCheckbox("pending")} />}
                            />
                          </Box>
                        }
                        <Box
                          style={{ "padding-left": "12px", "padding-right": "4px" }}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                          <FormControlLabel
                            sx={{ ml: "0!important" }}
                            style={{ fontSize: '14px' }}
                            label={t('label.filter.approve')}
                            control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[4]} onChange={() => handleCheckbox("approved")} />}
                          />
                        </Box>
                        <Box
                          style={{ "padding-left": "12px", "padding-right": "4px" }}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                          <FormControlLabel
                            sx={{ ml: "0!important" }}
                            style={{ fontSize: '14px' }}
                            label={t('label.filter.pendingDelete')}
                            control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[5]} onChange={() => handleCheckbox("pending_delete")} />}
                          />
                        </Box>
                      </Box>) : null
                    }
                  </Popover>
                  {((isOwner || isEvaluator) && isCreatable) &&
                    <Button
                      size="small"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={() => { gotoCreateGoal() }}
                      color="primary"
                      variant="contained"
                      style={{ textTransform: 'none' }}
                      disabled={workflowEnd || !isCreatable}
                      sx={{ height: "45px" }}
                    >
                      <PlusIcon className={classes.plusSvg} />
                      <Typography ml={1} style={{ color: fullVersion ? '#FFF' : '#FFF' }} fontSize="18px" fontWeight="500">{t("mygoal.label.createGoal")}</Typography>
                    </Button>
                  }
                </Grid>
              </Grid>
              <Grid container pt={'16px'}>
                <Grid item lg={12} md={12} style={{ paddingBottom: '30px' }}>
                  <Tabs
                    value={valueTab}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChangeTabs}
                    aria-label="Tabs"
                    TabIndicatorProps={{
                      style: {
                        height: "8px",
                        fontSize: "20px",
                      },
                    }}
                    style={{ borderBottom: '1px solid #DADADA' }}
                  >
                    <Tab sx={{ fontWeight: "400", minWidth: i18n.language === "th-TH" ? '60px' : '20px', maxWidth: i18n.language === "th-TH" ? '60px' : '20px' }} label={<span className={classes.root} style={{ textTransform: 'none', color: valueTab === 'all' ? "#5DA196" : "#404349" }}>{t("mygoal.label.all")}</span>} value="all" />
                    <Tab sx={{ fontWeight: "400" }} label={<span className={classes.root} style={{ textTransform: 'none', color: valueTab === 'personal' ? "#5DA196" : "#404349" }}>{t("mygoal.label.personal")}</span>} value="personal" />
                    <Tab sx={{ fontWeight: "400" }} label={<span className={classes.root} style={{ textTransform: 'none', color: valueTab === 'team' ? "#5DA196" : "#404349" }}>{t("mygoal.label.team")}</span>} value="team" />
                    <Tab sx={{ fontWeight: "400" }} label={<span className={classes.root} style={{ textTransform: 'none', color: valueTab === 'corporate' ? "#5DA196" : "#404349" }}>{t("mygoal.label.corporate")}</span>} value="corporate" />
                  </Tabs>
                </Grid>
                {/* <Grid lg={2} md={2} item pt={1} alignItems="center" sx={{marginBottom: "30px", display: 'flex', borderBottom: '1px solid #DADADA'}}>
                    <Box sx={{ flex: 1 }} />
                    {fullVersion && 
                      <Grid container direction="row" style={{justifyContent: 'flex-end'}}>
                        <Grid item>
                          <LinkIcon style={{width: '12px', height: '12px'}} className={classes.linkIcon} />
                        </Grid>
                        <Grid item ml={1} style={{marginTop: 3}}>
                          <Link
                            component={RouterLink}
                            to="#"
                          >
                            <Typography fontSize="12px" lineHeight="13.2px" fontWeight="300" variant="label" sx={{display: "flex", alignItems: "center" ,color: '#A0A0A0'}} classes={{ root: classes.btn }}>
                              {t("mygoal.label.gotoAchieve")}
                            </Typography>
                          </Link>
                        </Grid>
                      </Grid>
                    }
                </Grid> */}
              </Grid>
              {goalList.goal_list.map((item, key) => {
                let tmp = filter(hideData, (o) => {
                  let found = true
                  if (o.category?.name) {
                    found = (o.category?.name.toLowerCase() === item.name.toLowerCase())
                  }

                  return found
                })

                let fieldHideList = []
                for (const t of tmp) fieldHideList = [...fieldHideList, ...t.value]

                return (
                  <Grid key={key} style={{ marginBottom: '40px' }}>
                    <Grid container mt={2}>
                      <Grid item lg={12} md={12} sx={{ height: "60px" }}>
                        <Box sx={{ backgroundColor: `${item.color}`, padding: '0 15px', borderRadius: '5px', margin: '0 auto', height: "100%", display: "flex", alignItems: "center" }}>
                          <Grid container>
                            <Grid lg={11} md={12} item sx={{ display: 'flex', alignItems: 'center' }}>
                              <Icon style={{ color: '#FFFFFF', fontSize: 30 }}>{item.icon}</Icon>
                              {/* <InternalProcessIcon className={classes.internalIcon} /> */}
                              <Typography ml={2} fontWeight={600} fontSize={24} style={{ color: "white" }}>
                                {item.name}
                              </Typography>
                            </Grid>
                            <Grid lg={1} md={12} item xs={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                              <Box style={{ border: '1px solid white', borderRadius: '5px', marginLeft: 'auto', width: "60px", height: "35px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <Typography fontWeight={600} fontSize={18} style={{ color: "white", textAlign: 'center' }}>
                                  {item.weight} %
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                      <Grid container direction="row" style={{ justifyContent: 'space-between', marginTop: '20px', marginBottom: '20px' }}>
                        <Grid lg={12} xs={12}>
                          {(alertSummary && (100 - sumWeight(item.goal_items) > 0)) &&
                            <Box mt={2}>
                              <Alert
                                icon={true}
                                sx={{ color: "#CC6058", background: "#CC605826", borderRadius: "10px", position: "relative" }}
                              >
                                <Typography fontSize={14} lineHeight="19.12px" fontWeight={500} classes={{ root: classes.expire }} color="#404349">
                                  {`Adding ${100 - (sumWeight(item.goal_items))} weight to be able to submit for approval.`}
                                  {/* Calculate From All List Weight */}
                                </Typography>
                              </Alert>
                            </Box>
                          }
                        </Grid>
                        <Grid lg={11}>
                          <Grid container direction="row">
                            <Grid item>
                              <Typography fontSize={16} fontWeight="300" color="#A3A3A3">
                                {item.name} :&nbsp;
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography fontSize={16} fontWeight="300" variant="label" color="primary" >
                                {item.goal_items.filter((item) => {
                                  if (valueTab != 'all') {
                                    if (filterCheckbox.selectAll) {
                                      return item.type.code == valueTab
                                    } else {
                                      if (filterCheckbox[item.goal_status?.description]) {
                                        return item.type.code == valueTab
                                      }
                                    }
                                  } else {
                                    if (filterCheckbox.selectAll) {
                                      return item
                                    } else {
                                      if (filterCheckbox[item.goal_status?.description]) {
                                        return item
                                      }
                                    }
                                  }
                                }).length}
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Typography fontSize={16} fontWeight="300" color="#A3A3A3">
                                &nbsp;{t("mygoal.label.goalUnit")}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        {item.goal_items.filter((item) => {
                          if (valueTab != 'all') {
                            if (filterCheckbox.selectAll) {
                              return item.type.code == valueTab
                            } else {
                              if (filterCheckbox[item.goal_status?.description]) {
                                return item.type.code == valueTab
                              }
                            }
                          } else {
                            if (filterCheckbox.selectAll) {
                              return item
                            } else {
                              if (filterCheckbox[item.goal_status?.description]) {
                                return item
                              }
                            }
                          }
                        }).length > 1000 &&
                          <Grid pr={1}>
                            <Typography fontSize={14} style={{ cursor: 'pointer', color: '#5DA196', fontWeight: '500' }} onClick={() => { gotoSeeAll(item) }}>
                              {t("mygoal.label.seeAll")} &gt;
                            </Typography>
                          </Grid>
                        }
                      </Grid>
                      <Grid container direction="row" spacing={2}>
                        {
                          item.goal_items.filter((item) => {
                            if (valueTab != 'all') {
                              if (filterCheckbox.selectAll) {
                                return item.type.code == valueTab
                              } else {
                                if (filterCheckbox[item.goal_status?.description]) {
                                  return item.type.code == valueTab
                                }
                              }
                            } else {
                              if (filterCheckbox.selectAll) {
                                return item
                              } else {
                                if (filterCheckbox[item.goal_status?.description]) {
                                  return item
                                }
                              }
                            }
                          }).length > 0
                            ?
                            item.goal_items.filter((item) => {
                              if (valueTab != 'all') {
                                if (filterCheckbox.selectAll) {
                                  return item.type.code == valueTab
                                } else {
                                  if (filterCheckbox[item.goal_status?.description]) {
                                    return item.type.code == valueTab
                                  }
                                }
                              } else {
                                if (filterCheckbox.selectAll) {
                                  return item
                                } else {
                                  if (filterCheckbox[item.goal_status?.description]) {
                                    return item
                                  }
                                }
                              }
                            }).map((list, key) => {

                              let allow_edit = isOwner || (isEvaluator && isCreatable)//(isOwner && ((list?.type?.code === 'team' && list.is_owner) || list?.type?.code !== 'team'))
                              //console.log('allow_edit', list.serial, list.name, allow_edit, isOwner, isEvaluator, isCreatable)

                              let list_menu = [...options]
                              if (!allow_edit) list_menu = [t('mygoal.label.viewDetail')]

                              return (
                                key < 1000 &&
                                <Grid item lg={6} xs={12} key={key}>
                                  <Card style={{ minHeight: "410px", height: '100%' }}>
                                    <CardContent>
                                      <Grid lg={12} xs={12} container>
                                        <Grid
                                          item
                                          lg={8}
                                          xs={12}
                                          display="flex"
                                          alignItems="center"
                                          textAlign="left"
                                        >
                                          <Grid item>
                                            <BootstrapTooltip
                                              placement="right"
                                              arrow
                                              title={list.name}
                                              style={{ marginLeft: '5px' }}
                                            >
                                              <Typography fontSize={20} lineHeight="15px" color="#404349" fontWeight="600" onClick={() => { gotoDetail(list) }} style={{ cursor: 'pointer' }}
                                                sx={{
                                                  display: '-webkit-box',
                                                  overflow: 'hidden',
                                                  WebkitBoxOrient: 'vertical',
                                                  WebkitLineClamp: 2,
                                                  lineHeight: '24px'
                                                }}
                                              >
                                                {list.name}
                                              </Typography>
                                            </BootstrapTooltip>
                                          </Grid>
                                        </Grid>
                                        <Grid
                                          item
                                          lg={4}
                                          xs={12}
                                          display="flex"
                                          alignItems="right"
                                          justifyContent="right"
                                          style={{ justifyContent: 'flex-end' }}
                                        >
                                          <Grid item mt={0.3}>

                                            {fieldHideList.indexOf('goal_progress') === -1 &&
                                              <>
                                                {statusBox(Object.keys(list.progress_status).length > 0 ? list.progress_status : goalProgressMockup)}
                                              </>
                                            }
                                          </Grid>
                                          <Grid item sx={{ paddingLeft: '15px', paddingTop: '3px' }}>
                                            <IconButton
                                              aria-label="more"
                                              id="long-button"
                                              aria-controls={openOption ? 'long-menu' : undefined}
                                              aria-expanded={openOption ? 'true' : undefined}
                                              aria-haspopup="true"
                                              onClick={(e) => handleClick(e, list)}
                                              sx={{
                                                borderRadius: '5px', border: '1px solid #E5E5E5', paddingLeft: '1px', paddingRight: '1px', paddingTop: '6px', paddingBottom: '6px',
                                                "&:hover": {
                                                  backgroundColor: "#EFF6F4"
                                                }
                                              }}
                                            >
                                              <MoreVertIcon />
                                              {/* style={{border: '1px solid #DADADA'}} */}
                                            </IconButton>
                                          </Grid>
                                          <Menu
                                            id="long-menu"
                                            MenuListProps={{
                                              'aria-labelledby': 'long-button',
                                            }}
                                            anchorEl={anchorEl}
                                            open={openOption}
                                            onClose={handleOption}
                                            PaperProps={{
                                              style: {
                                                maxHeight: 48 * 4.5,
                                                width: '20ch',
                                                boxShadow: '0 0 1px 0 rgb(160 160 160 / 31%), 0 2px 6px -3px rgb(160 160 160 / 25%)',
                                              },
                                            }}
                                          >
                                            {list_menu.map((option) => (
                                              <MenuItem key={option} onClick={() => handleOption(option, goalDetailData)}
                                                disabled={
                                                  (option === t('mygoal.label.delete') && goalDetailData?.is_owner === false)
                                                  || (option === t('mygoal.label.edit') && goalDetailData?.progress_status?.description === 'pending_delete')
                                                  || ((option == t('mygoal.label.edit') || option == t('mygoal.label.delete')) && workflowEnd)
                                                  || ((option == t('mygoal.label.edit') || option == t('mygoal.label.delete')) && !isCreatable)
                                                  || ((option == t('mygoal.label.delete')) && undeleteList.indexOf('is_approved') !== -1 && goalDetailData?.is_approved)
                                                  //|| ((option == t('mygoal.label.edit') || option == t('mygoal.label.delete')) && !isCreatable)
                                                  //|| ((option == t('mygoal.label.edit') || option == t('mygoal.label.delete')) && !isCreatable)
                                                } sx={{ color: (option === t('mygoal.label.delete') && goalDetailData?.progress_status?.description === 'pending_delete') ? '#CC6058' : "#404349" }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#EFF6F4'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = '#ffffff'}
                                              >
                                                {
                                                  option == t('mygoal.label.viewDetail') ?
                                                    <EyeIcon style={{ marginTop: '5px', marginRight: '5px' }} />
                                                    : (option == t('mygoal.label.edit')) ?
                                                      <EditIcon style={{ marginTop: '5px', marginRight: '5px' }} className={fullVersion ? {} : classes.inactiveSvg} />
                                                      : option === t('mygoal.label.delete') &&
                                                        goalDetailData?.progress_status?.description === 'pending_delete' ?
                                                        <CancelDelete style={{ marginTop: '5px', marginRight: '5px' }} className={fullVersion ? {} : classes.inactiveSvg} />
                                                        : <DeleteIcon style={{ marginTop: '5px', marginRight: '5px' }} className={fullVersion ? {} : classes.inactiveSvg} />
                                                }
                                                {(option === t('mygoal.label.delete') && goalDetailData?.progress_status?.description === 'pending_delete') ? t('mygoal.label.cancelDeleteBtn') : option}
                                              </MenuItem>
                                            ))}
                                          </Menu>
                                        </Grid>
                                      </Grid>
                                      <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                                      <Grid container lg={12} xs={12} mt={3}>
                                        <Grid lg={4} xs={12} mb={'15px'}>
                                          <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                                            {t("mygoal.label.goalWeight")}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={8} xs={12} mb={'15px'}>
                                          <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                                            {list.weight} %
                                          </Typography>
                                        </Grid>
                                        <Grid lg={4} xs={12} mb={'15px'}>
                                          <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                                            {t("mygoal.label.goalMetric")}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={8} xs={12} mb={'15px'}>
                                          <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                                            {list.metric.description}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={4} xs={12} mb={'15px'}>
                                          <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                                            {t("mygoal.label.goalType")}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={8} xs={12} mb={'15px'}>
                                          <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                                            {list.type.description}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={4} xs={12} mb={'15px'}>
                                          <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                                            {t("mygoal.label.startEndDate")}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={8} xs={12} mb={'15px'}>
                                          <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                                            {`${list.start_date} - ${list.end_date}`}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={4} xs={12} mb={'15px'}>
                                          <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                                            {t("mygoal.label.measurement")}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={8} xs={12} mb={'15px'}>
                                          <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                                            {`${list.measurement || "-"}`}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={4} xs={12} mb={'15px'}>
                                          <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                                            {t("mygoal.label.targetValue")}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={8} xs={12} mb={'15px'} mt={'5px'}>
                                          <Grid container direction="row">
                                            {list.target_condition &&
                                              <Grid item sx={{ marginRight: '5px' }}>
                                                <Typography fontSize={18} lineHeight="21px" fontWeight={400} color="#404349">
                                                  {Util.upperFirstWord(list.target_condition) ?? ''}
                                                </Typography>
                                              </Grid>
                                            }
                                            <Grid item>
                                              {convertDateFormat(list)}
                                            </Grid>
                                          </Grid>
                                        </Grid>

                                        {fieldHideList.indexOf('actual_value') === -1 &&
                                          <>
                                            <Grid lg={4} xs={12} mb={'15px'}>
                                              <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                                                {t("mygoal.label.actualValue")}
                                              </Typography>
                                            </Grid>
                                            <Grid lg={5} xs={12} mb={'15px'}>
                                              <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                                                {`${list.actual_value ? `${list.actual_value} ${list.unit?.description || ''}` : '-'}`}
                                              </Typography>
                                            </Grid>

                                            <Grid lg={3} xs={12} mb={'15px'}>
                                              <Typography fontSize={14} lineHeight="29px" fontWeight={500} color="#4085C9" textAlign={'right'}>
                                                {`${list.scale_level_current ? `${list.scale_level_current}` : ''}`}
                                              </Typography>
                                            </Grid>
                                          </>
                                        }


                                        {(list?.created_by && !list?.updated_by) &&
                                          <>
                                            <Grid lg={4} xs={12} mb={'15px'}>
                                              <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                                                {t("admin.label.createdBy")}
                                              </Typography>
                                              <Typography fontSize={16} lineHeight="29px" fontWeight={400} color="#404349">
                                                {list?.created_by}
                                              </Typography>
                                              <Typography fontSize={12} fontWeight={400} color="#404349">
                                                {list?.created_at ?? ''}
                                              </Typography>
                                            </Grid>
                                            <Grid lg={8} xs={12} mb={'15px'}>
                                              <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                                                {list?.remark ?? '-'}
                                              </Typography>
                                            </Grid>
                                          </>
                                        }


                                        {(list?.updated_by) &&
                                          <>
                                            <Grid lg={4} xs={12} mb={'15px'}>
                                              <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#A3A3A3">
                                                {t("mygoal.label.editedBy")}
                                              </Typography>
                                              <Typography fontSize={16} lineHeight="29px" fontWeight={400} color="#404349">
                                                {list?.updated_by ?? ''}
                                              </Typography>
                                              <Typography fontSize={12} fontWeight={400} color="#404349">
                                                {list?.updated_at ?? ''}
                                              </Typography>
                                            </Grid>
                                            <Grid lg={8} xs={12} mb={'15px'}>
                                              <Typography fontSize={18} lineHeight="29px" fontWeight={400} color="#404349">
                                                {list?.remark ?? '-'}
                                              </Typography>
                                            </Grid>
                                          </>
                                        }


                                      </Grid>
                                      <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                                      <Grid container direction="row" style={{ alignItems: 'center', paddingTop: "15px" }}>
                                        <Grid xs={12} lg={6}>
                                          <BootstrapTooltip
                                            placement="right"
                                            arrow
                                            title={list.owner?.full_name}
                                            style={{ marginLeft: '5px' }}
                                          >
                                            <Avatar
                                              src={list.owner?.photo}
                                              sx={{
                                                width: 30,
                                                height: 30,
                                              }}
                                            >
                                            </Avatar>
                                          </BootstrapTooltip>
                                        </Grid>
                                        {
                                          isOwner &&
                                          <Grid xs={12} lg={6} style={{ textAlign: 'right', paddingRight: '5px', }}>
                                            {(statusForm?.name === 'approved' && list.is_owner === true)
                                              ?
                                              <Typography color='#5DA196' style={{ cursor: 'pointer' }} onClick={() => { setDataForUpdateDialog(list) }}>
                                                <Icon style={{ color: '#5DA196', fontSize: 18, paddingTop: "3px", marginRight: "3px" }}>{'rotate_left'}</Icon>
                                                {t("mygoal.label.update")}
                                              </Typography>
                                              :
                                              <Typography color='#DADADA'>
                                                <Icon style={{ color: '#DADADA', fontSize: 18, paddingTop: "3px", marginRight: "3px" }}>{'rotate_left'}</Icon>
                                                {t("mygoal.label.update")}
                                              </Typography>
                                            }
                                          </Grid>
                                        }
                                      </Grid>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              )
                            })
                            :
                            <Card style={{ width: '50%', marginLeft: '20px', marginTop: '10px' }} >
                              <Grid container>
                                <Grid item lg={12} md={12}>
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    flexDirection="column"
                                    pt={20}
                                    pb={20}
                                  >
                                    <Box>
                                      <img src={fileBrowser} alt="browser" />
                                    </Box>
                                    <Box>
                                      <Typography style={{ color: '#939393', fontSize: '14px', fontWeight: '500' }}>{t("mygoal.label.noData")}</Typography>
                                    </Box>
                                    <Box>
                                      {(workflowEnd || !isCreatable)
                                        ?
                                        <></>
                                        :
                                        <Typography
                                          style={{ color: '#5DA196', fontSize: '14px', fontWeight: '500', textDecoration: 'underline', cursor: 'pointer' }}
                                          onClick={() => { gotoCreateGoal(item.code) }}
                                        >
                                          {t("mygoal.label.clickHereToAdd")} {item.name}
                                        </Typography>
                                      }
                                    </Box>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Card>
                        }
                      </Grid>
                    </Grid>
                  </Grid>
                )
              })
              }
              <Dialog onBackdropClick={() => { return false }} open={isUpdateDialogOpen} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm" PaperProps={{ sx: { padding: '10px' } }}>
                <DialogContent px={0} pb={0}>
                  <Grid container direction="row">
                    <Grid item lg={11}>
                      <Typography fontSize={24} fontWeight="600" color="#404349">
                        {t('mygoal.label.updateGoal')}
                      </Typography>
                    </Grid>
                    <Grid item lg={1} style={{ textAlign: 'right' }}>
                      <Typography color='#404349' style={{ cursor: 'pointer', paddingTop: '8px' }} onClick={handleCloseDialog}>
                        X
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider sx={{ paddingTop: "20px" }} />
                  <Grid container>
                    <Grid item lg={4} mt={2}>
                      <Typography fontSize={16} color="#939393">
                        {t('mygoal.label.goalToUpdate')}
                      </Typography>
                    </Grid>
                    <Grid item lg={8} mt={2}>
                      <Typography color="primary">
                        {goalDetail.goal?.name}
                      </Typography>
                    </Grid>
                    <Grid item lg={4} mt={2}>
                      <Typography fontSize={16} color="#939393">
                        {t('mygoal.label.goalMetric')}
                      </Typography>
                    </Grid>
                    <Grid item lg={8} mt={2}>
                      <Typography color="#404349">
                        {goalDetail.goal_progress?.goal_metric.description}
                      </Typography>
                    </Grid>
                    <Grid item lg={4} mt={2}>
                      <Typography fontSize={16} color="#939393">
                        {t('mygoal.label.targetValue')}
                      </Typography>
                    </Grid>
                    <Grid item lg={8} mt={2}>
                      <Typography color="#404349">
                        {Util.upperFirstWord(conditionBackup ?? '')} {goalDetail.goal_progress?.target_value} {goalDetail.goal_progress?.unit && goalDetail.goal_progress?.unit !== "-" ? goalDetail.goal_progress?.unit : ""}
                      </Typography>
                    </Grid>
                    <Grid item lg={4} mt={2} pt={'7px'}>
                      <Typography style={{ fontSize: 16 }} color="#939393">
                        {t('corporateGoal.label.resultAsOf')}:
                      </Typography>
                    </Grid>
                    <Grid item lg={8} mt={2} color="#404349">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          format="dd/MM/yyyy"
                          value={asOfDate}
                          onChange={(newValue) => {
                            if (newValue) {
                              setAsOfDate(Util.formatDate(newValue));
                            } else {
                              setAsOfDate(null)
                            }
                          }}
                          style={{ color: '#404349', fontWeight: '400', fontSize: '16px', borderColor: asOfDate ? '#CED4DA' : '#CC6058' }}
                          inputProps={{
                            placeholder: "As of date", sx: {
                              "&::placeholder": {
                                color: "#AAAAAA"
                              },
                              "&borderColor": {
                                color: '#CED4DA'
                              },
                              "color": '#404349'
                            }
                          }}
                          renderInput={(params) => <TextField {...params}
                            fullWidth
                            size="small"
                            style={{ color: '#404349' }}
                          />}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item lg={4} mt={2} pt={'7px'}>
                      <Typography style={{ fontSize: 16 }} color="#939393">
                        {t('corporateGoal.label.actualValue')}:
                      </Typography>
                    </Grid>
                    <Grid item lg={8} mt={2} color="#404349">
                      {goalDetail?.goal_progress?.goal_metric?.options?.type === 'date'
                        ?
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <Grid container direction="row">
                            <Grid item lg={10}>
                              <DesktopDatePicker
                                format="dd/MM/yyyy"
                                value={targetValue}
                                onChange={(newValue) => {
                                  if (newValue) {
                                    setTargetValue(Util.formatDate(newValue));
                                  } else {
                                    setTargetValue(null)
                                  }
                                }}
                                style={{ color: '#404349', fontWeight: '400', fontSize: '16px', borderColor: targetValue ? '#CED4DA' : '#CC6058' }}
                                inputProps={{
                                  placeholder: "Current Value", sx: {
                                    "&::placeholder": {
                                      color: "#AAAAAA"
                                    },
                                    "&borderColor": {
                                      color: '#CED4DA'
                                    },
                                    "color": '#404349'
                                  }
                                }}
                                renderInput={(params) => <TextField {...params}
                                  fullWidth
                                  size="small"
                                  style={{ color: '#404349' }}
                                />}
                              />
                            </Grid>
                            <Grid item>
                              <IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginLeft: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>
                            </Grid>
                          </Grid>
                        </LocalizationProvider>
                        :
                        (!goalDetail?.goal_progress?.goal_metric?.options)
                          ?
                          <FormControl fullWidth>
                            <Select
                              displayEmpty
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              size="small"
                              value={targetValue}
                              onChange={(val) => { setTargetValue(val.target.value) }}
                              renderValue={(selected) => {
                                if (selected === null || selected === '') {
                                  return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>;
                                } else {
                                  return <Typography color="#404349">{selected}</Typography>
                                }
                              }}
                              endAdornment={<IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginRight: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>}
                            >
                              <MenuItem value={''}>
                                <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>
                              </MenuItem>
                              <MenuItem value={"Success"}>Success</MenuItem>
                              <MenuItem value={"Fail"}>Fail</MenuItem>
                            </Select>
                          </FormControl>
                          :
                          <TextField
                            autoComplete='off'
                            style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={targetValue} onChange={(e) => setTargetValue(e.target.value.replace(/[^\d.]|\.(?=.*\.)/g, ''))} placeholder={t("corporateGoal.label.fillTheActualValue")} variant="outlined" size="small" fullWidth
                            InputProps={{
                              endAdornment: targetValue ? (
                                <IconButton onClick={handleClearClick}>
                                  <ClearIcon />
                                </IconButton>
                              ) : undefined
                            }}
                          />

                      }
                      {
                        goalScaleData &&
                        <Typography fontSize={14} lineHeight="21px" fontWeight="500" color="#4085C9" textAlign="left" sx={{ textTransform: "uppercase", mt: 1 }}>
                          {goalScaleData}
                        </Typography>
                      }
                    </Grid>
                    {/* <Grid item lg={2}></Grid> */}
                    <Grid item lg={4} mt={2} pt={'7px'}>
                      <Typography style={{ fontSize: 16 }} color="#939393">
                        {t('mygoal.label.goalProgress')}:
                      </Typography>
                    </Grid>
                    <Grid item lg={8} mt={2}>
                      <FormControl fullWidth>
                        <Select
                          displayEmpty
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          value={progressValue}
                          onChange={(val) => { setProgressValue(val.target.value) }}
                          sx={{ color: "#404349" }}
                          renderValue={(selected) => {
                            if (selected === null) {
                              return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>Fill the goal progress</Typography>;
                            } else {
                              return goalProgressOption?.find((item) => item.serial === selected)?.name
                              // Mockup Because api is not working
                            }
                          }}
                        >
                          <MenuItem disabled value={null}>
                            <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>Fill the goal progress</Typography>
                          </MenuItem>
                          {goalProgressOption?.map((item, key) => {
                            return <MenuItem key={key} value={item.serial} sx={{ color: "#404349" }}>{item.name}</MenuItem>
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item lg={12} mt={2} pt={'7px'}>
                      <Typography style={{ fontSize: 16 }} color="#939393">
                        {t('corporateGoal.label.remark')}:
                      </Typography>
                    </Grid>
                    <Grid item lg={12} pt={'7px'}>
                      <TextField
                        autoComplete='off'
                        multiline
                        rows={2}
                        maxRows={4}
                        style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={remark} onChange={(e) => setRemark(e.target.value)} placeholder={`Fill the remark`} variant="outlined" size="small" fullWidth
                      />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                  <Box classes="mt-3">
                    <Button onClick={handleCloseDialog} color="black" variant="outlined" style={{ marginRight: '35px', paddingLeft: '48px', paddingRight: '48px', textTransform: 'none', borderColor: '#DADADA !important' }}>
                      {t('mygoal.label.cancel')}
                    </Button>
                    <Button onClick={() => updateGoal()} color="primary" variant="contained" style={{ paddingLeft: '48px', paddingRight: '48px', textTransform: 'none' }}>
                      <Typography>
                        {t('mygoal.label.justUpdate')}
                      </Typography>
                    </Button>
                  </Box>
                </DialogActions>
              </Dialog>
              <WarningDialog open={isApproveDialogOpen} doConfirm={handleConfirmApprove} setValue={handleConfirmApproveDialog} title={t(isEvaluator ? 'mygoal.label.submitAndApproveBtn' : 'mygoal.popup.submitApprove')} text={t('mygoal.popup.submitApproveDesc')} haveComment={isEvaluator} />
              <ConfirmDialog open={isConfirmDeleteDialogOpen} trash={true} doConfirm={handleConfirmDeleteList} setValue={handleConfirmDeleteDialog} title={`${t("mygoal.label.confirmDelete")}`} text={`${t("mygoal.label.confirmDeleteDesc")}`} cancel={t('mygoal.label.no')} confirm={t('mygoal.label.yes')} />
              <ConfirmDialog open={isCancelDeleteDialogOpen} trash={true} doConfirm={handleCancelDeleteList} setValue={handleCancelDeleteDialog} title={`${t("mygoal.label.cancelDelete")}`} text={`${t("mygoal.label.cancelDeleteDesc")}`} cancel={t('mygoal.label.no')} confirm={t('mygoal.label.yes')} />

              <SimpleDialog open={isSuccessApprovalOpen} setValue={openSuccessApprovalOpen} text={t('mygoal.popup.approved')} />
              <AlertDialog
                open={isAlertDialogOpen}
                title={title}
                message={message}
                type={typeAlertDialog}
                color={color}
                close={onCloseAlertDialog}
                acceptConfirm=""
                colorHover={colorHover}
                size={size}
              />
              <SimpleDialog open={isSuccessAddDialogOpen} setValue={openSuccessAddDialog} title={t('mygoal.popup.success')} text={t('mygoal.popup.update')} />
              <SimpleDialog open={isSuccessDeleteDialogOpen} setValue={openSuccessDeleteDialog} title={t('mygoal.popup.success')} text={t('mygoal.popup.deletedGoal')} />
              <SimpleDialog open={isSuccessCancelDeleteDialogOpen} setValue={openSuccessCancelDeleteDialog} title={t('mygoal.popup.successCancel')} text={t('mygoal.popup.successCancelDesc')} />
              <MessageDialog open={openFailedMessageDialog} setValue={handleCloseFailedMessageDialog} type="fail" title={t('mygoal.popup.fail')} text={errorText + ` ${t('mygoal.popup.again')}`} />

              <ConfirmAdjustGoal action={handleAdjust} open={openAdjust} setValue={setOpenAdjust} text={t('inbox.label.dialog.' + (isEvaluator ? 'adjustGoal' : 'requestAdjustGoal'))} type="reject" required={true} />

            </Grid>
          }
        </Container>
      </Box>
      {Util.ScrollToTop()}
    </Box>
  );
};
export default MyGoal;
